"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FULL_USER_STORES = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_FULL_USER_STORES = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetFullUserStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      results {\n        ...FullStore\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetFullUserStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      results {\n        ...FullStore\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1.FULL_STORE_FRAGMENT);
var templateObject_1;
